'use client'

import { useEvaluations } from '../hooks/useEvaluations'
import { buildSummary, KIND_BADGE } from '../lib/evaluation-ui'

import { AppLink } from '@/shared/lib/router'
import { cn } from '@/shared/lib/utils'
import {
  Card,
  CardBody,
  CardHeader,
  CardRewards,
  CardTile,
  CardTitle
} from '@/shared/ui/Card'
import { Page } from '@/shared/ui/Page'
import { StatusScreen } from '@/shared/ui/StatusScreen'

export function EvaluationsListPage() {
  const { evaluations, isLoading, isError } = useEvaluations()

  if (isLoading)
    return (
      <StatusScreen
        variant="purple"
        title="Carregando avaliações"
        description="Só um instante."
      />
    )

  if (isError)
    return (
      <StatusScreen
        variant="purple"
        title="Não deu para carregar"
        description="Tente de novo daqui a pouco."
      />
    )

  if (evaluations.length === 0)
    return (
      <StatusScreen
        variant="purple"
        title="Nenhuma avaliação por aqui"
        description="Quando houver uma avaliação disponível para você, ela aparece nesta tela."
      />
    )

  return (
    <Page variant="purple">
      <Card variant="purple">
        <CardHeader>
          <CardTitle>Avaliações</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="flex flex-col gap-4">
            {evaluations.map(evaluation => {
              const badge = KIND_BADGE[evaluation.kind]
              const finished = !!evaluation.finished

              return (
                <AppLink
                  key={evaluation.id}
                  href={`/avaliacoes/${evaluation.id}`}
                  className="block"
                >
                  <CardTile className="cursor-pointer bg-linear-to-t from-[#E4E8FA] to-[#DDD4FF] transition-all duration-100 hover:shadow-[0_2px_0_0_#C7BFFF]">
                    <img
                      src="/icons/evaluations.svg"
                      alt=""
                      aria-hidden
                      className="size-14 shrink-0 lg:size-16"
                    />

                    <div className="flex min-w-0 grow flex-col items-start gap-1">
                      <span
                        className="text-md block font-medium text-primary-dark"
                        style={{ overflowWrap: 'anywhere' }}
                      >
                        {evaluation.name}
                      </span>

                      <div className="flex flex-wrap gap-2">
                        <span
                          className={cn(
                            'block rounded-sm px-1 text-xs font-normal text-white',
                            badge.className
                          )}
                        >
                          {badge.label}
                        </span>
                        {finished ? (
                          <span className="block rounded-sm bg-guaco px-1 text-xs font-normal text-white">
                            Respondida
                          </span>
                        ) : null}
                      </div>

                      {evaluation.description ? (
                        <span className="line-clamp-2 block text-sm font-medium text-[#434368]">
                          {evaluation.description}
                        </span>
                      ) : null}

                      <span className="block text-xs font-medium text-[#7F7FAD]">
                        {buildSummary(evaluation)}
                      </span>
                    </div>

                    <CardRewards
                      coinReward={evaluation.coin_reward}
                      pointReward={evaluation.point_reward}
                      completed={finished}
                      claimed={finished}
                      withClaimedBadge
                      className="ml-auto shrink-0"
                    />
                  </CardTile>
                </AppLink>
              )
            })}
          </div>
        </CardBody>
      </Card>
    </Page>
  )
}
